import { Outlet } from "react-router-dom";
import StorefrontHeader from "@/components/storefront/Header";
import StorefrontFooter from "@/components/storefront/Footer";
import MobileBottomBar from "@/components/storefront/MobileBottomBar";
import WhatsAppFAB from "@/components/storefront/WhatsAppFAB";

export default function StorefrontLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-[#0A0A0B] text-white">
            <StorefrontHeader />
            <main className="flex-1 pb-safe">
                <Outlet />
            </main>
            <StorefrontFooter />
            <MobileBottomBar />
            <WhatsAppFAB />
        </div>
    );
}
